export const SET_DICTIONARY = 'SET_DICTIONARY';
export const SET_SERVICE_RECORD_SHEET = 'SET_SERVICE_RECORD_SHEET';
export const SET_PRINT = 'SET_PRINT';
export const SET_PRINT_WITH_DETAIL = 'SET_PRINT_WITH_DETAIL';
export const SET_IS_COPY_DATA = 'SET_IS_COPY_DATA';
export const SET_SETTINGS = 'SET_SETTINGS';
